import {
      SocialDefaultImage,
      HomeOgImage,
      PlatformOgImage,
      AgencyBankingOgImage,
      EkycSolutionOgImage,
      MobileMoneyPaymentSolutionsOgImage,
      PrepaidCardsSolutionOgImage,
      WalletAsServicesOgImage,
      CardAsServicesOgImage,
      AddressVerificationOgImage,
      EKycAsServicesOgImage,
      AgencyBankingInEastAfricaOgImage,
      AmlScreeningOgImage,
      CashlessPaymentSolutionForEventsAndConferencesOgImage,
      CrossBorderPaymentSolutions1OgImage,
      DigipayTopNotchApplicationSecurityOgImage,
      DigitalFintechSoftwareSolutionOgImage,
      EvolutionOfDigitalWalletAndMobilePaymentOgImage,
      EwalletForParkingPaymentSolutionsOgImage,
      EwalletForTollRoadPaymentSolutionsOgImage,
      EwalletFuelSolutionsOgImage,
      EwalletSolutionForEntertainmentAndAmusementParkOgImage,
      FaceVerificationOgImage,
      FraudPreventionOgImage,
      InvoicePaymentsMerchantAcquiringSolutionOgImage,
      loyaltyAndRewardsSolutionsOgImage,
      MerchantAcquiringSolutionOgImage,
      MerchantPaymentSolutionsOgImage,
      MicroFinanceSolutionsOgImage,
      MposMobilePointOfSaleSolutionsOgImage,
      MposSolutionOgImage,
      PrepaidCardRetailRevolutionOgImage,
      QrPaymentsMerchantAcquiringSolutionOgImage,
      TapToPhoneMerchantAcquiringSolutionOgImage,
      TransformingKycExperienceForBanksOgImage

} from "../utils/imageConst";

export const HomeMeta = {
      metaTitle: `Digital Payment Solutions & White Label FinTech Platform: DGpay`,
      metaDescription: "DigiPay.Guru helps banks, fintechs, telcos, NBFIs, and other financial businesses launch secure, scalable, and fully branded digital payment solutions in weeks!",
      ogTitle: "",
      ogDescription: "",
      ogType: "website",
      ogSiteName: "",
      ogImage: HomeOgImage,
      twitterCard: "",
      twitterCreator: "",
      twitterTitle: "",
      twitterDescription: "",
      twitterImage: HomeOgImage
};

export const PlatformMeta = {
      metaTitle: `DGPay-Advanced White-Label Digital Payment Solution Platform`,
      metaDescription: "DGPay+: Customer-centric digital payment solution platform with a cluster of top-notch financial products. eWallets, Remittance, Agency Banking, Cards & eKYC.",
      ogImage: PlatformOgImage,
      twitterImage: PlatformOgImage
};

export const MobileMoneyMeta = {
      metaTitle: `Best eWallet Solution & Mobile Payment Software Platform: DGpay`,
      metaDescription: "DigiPay.Guru’s eWallet solution is a secure and reliable Mobile Money Payment System to empower banks, fintech, financial institutions, NBFCs, Telcos, and more.",
      ogImage: MobileMoneyPaymentSolutionsOgImage,
      twitterImage: MobileMoneyPaymentSolutionsOgImage
};

export const PrepaidCardsSolutionMeta = {
      metaTitle: `Best Prepaid Card Issuance Platform, Prepaid Card Solution`,
      metaDescription: "A top-notch prepaid card issuance platform for issuing, activating, and managing your prepaid card programs most securely and efficiently - DigiPay.Guru.",
      ogImage: PrepaidCardsSolutionOgImage,
      twitterImage: PrepaidCardsSolutionOgImage
};

export const DigitalFintechSolutionNbfcsMeta = {
      metaTitle: `Top Digital Fintech Solutions for NBFCs | DigiPay Guru`,
      metaDescription: "Revolutionize your NBFC with AI-driven fintech solutions. Improve digital lending, payments & compliance. Explore DigiPay Guru’s innovative platform now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const DigitalFintechSolutionbanksMeta = {
      metaTitle: `Fintech Solutions for Banks | White Label Banking Platform`,
      metaDescription: "Discover how DigiPay.Guru’s reliable and secure digital fintech solutions transform your business and boost your profits | Banks",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const DigitalWalletSolutionMeta = {
      metaTitle: `White-Label Digital Wallet Software Solution Provider: DGpay`,
      metaDescription: "Get started with our reliable digital wallet software solution for banks, fintechs, & financial institutions. Offer digital wallet services without storing user funds.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const AgencyBankingMeta = {
      metaTitle: `Branchless Agency Banking Software Solution | DigiPay.Guru`,
      metaDescription: "A reliable branchless banking solution to help banks make banking services accessible to their customers anywhere. And boost profits and customer satisfaction.",
      ogImage: AgencyBankingOgImage,
      twitterImage: AgencyBankingOgImage
};

export const DigitalMoneyTransferSolutionsMeta = {
      metaTitle: `Money Transfer International Remittance Software Solution`,
      metaDescription: "DGpay cross-border payment solution to offer simplified global money transfers for your customers. International remittance software for banks, MTOs, FIs, & more.",
      ogImage: CrossBorderPaymentSolutions1OgImage,
      twitterImage: CrossBorderPaymentSolutions1OgImage
};

export const MultipleCorridorsAndExchangeRateManagementMeta = {
      metaTitle: `Multiple Corridors & Exchange Rate Management - DigiPay.Guru`,
      metaDescription: "Enhance your international remittance platform with multiple corridors and dynamic FX rates. Optimize costs, streamline transactions, and boost global reach.",
      ogImage: CrossBorderPaymentSolutions1OgImage,
      twitterImage: CrossBorderPaymentSolutions1OgImage
};
export const AgentnetworkmoduleMeta = {
      metaTitle: `Agent network module - DigiPay.Guru`,
      metaDescription: "Enhance your international remittance platform with our Agent Network Module. Streamline operations, manage agents, and track performance effortlessly.",
      ogImage: CrossBorderPaymentSolutions1OgImage,
      twitterImage: CrossBorderPaymentSolutions1OgImage
};
export const BulkPaymentsForEwalletMeta = {
      metaTitle: `Bulk Payment System | Wholesale Payment Solution | DigiPay.Guru`,
      metaDescription: "Empower your eWallet platform with bulk payment services. Streamline your client’s payouts, enhance client satisfaction, and reduce operational errors. DigiPay.Guru",
      ogImage: CrossBorderPaymentSolutions1OgImage,
      twitterImage: CrossBorderPaymentSolutions1OgImage
};

export const MerchantPaymentSolutionsMeta = {
      metaTitle: `POS Merchant Payment System & Solution | Merchant QR Code`,
      metaDescription: "A merchant payment processing solution with POS, & QR code capabilities designed to offer multiple payment options, quick settlements, & personalized offers.",
      ogImage: MerchantPaymentSolutionsOgImage,
      twitterImage: MerchantPaymentSolutionsOgImage
};
export const AboutMeta = {
      metaTitle: `About DigiPay.Guru - Our Trusted Whitelabel Fintech Platform`,
      metaDescription: "Our vision, mission, team, and USPs as the most reliable & secure financial service provider empowering fintech innovators with white-label fintech solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const OurUspMeta = {
      metaTitle: `API Driven Fintech Solution Provider USP | DigiPay.Guru`,
      metaDescription: "Top-notch digital payment solutions with success-worthy USPs to transform fintech businesses. Scalable, customizable, & omnichannel white-label solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const TopNotchApplicationSecurityMeta = {
      metaTitle: `PCI SSF-Certified Digital Payment Security Solution | Digipay.Guru`,
      metaDescription: "Leverage advanced security for your digital payment platforms from DigiPay.Guru. Protect your digital payments, ensure compliance and secure transactions.",
      ogImage: DigipayTopNotchApplicationSecurityOgImage,
      twitterImage: DigipayTopNotchApplicationSecurityOgImage
};
export const FraudPreventionMeta = {
      metaTitle: `Secure Payment Solution to Prevent Digital Payment Frauds`,
      metaDescription: "Secure digital payment solutions with in-house fraud detection, anti-fraud strategy, and advanced tech like 3D Secure & Biometrics to prevent all payment fraud.",
      ogImage: FraudPreventionOgImage,
      twitterImage: FraudPreventionOgImage
};
export const BlogMeta = {
      metaTitle: `Fintech Insights & Digital Payments Blog | Digipay Guru`,
      metaDescription: "Stay ahead with the latest trends in fintech, digital wallets, eKYC, remittances & mobile payments. Explore expert insights to scale your business.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const BlogCategoryMeta = {
      metaTitle: `Read the latest fintech blogs`,
      metaDescription: "Explore DigiPay.Guru’s well-researched blogs and articles to access the latest trends, tips, news, updates, and expert insights.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const BlogAuthorMeta = {
      metaTitle: `Author bio of our Fintech Expert`,
      metaDescription: "Gain valuable insights on various FinTech topics from our expert author. Stay updated on industry trends & innovations at Digipay Guru's blog.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};


export const ProductMeta = {
      metaTitle: `Fintech Digital Wallet, Cards, Payment Platform & Product`,
      metaDescription: "Stay updated with our advanced digital wallet platform’s latest features for an enhanced payment experience including cards, split & schedule payments, and more",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const CaseStudiesMeta = {
      metaTitle: `Fintech Products, Digital Wallet Software Case Studies`,
      metaDescription: "Case studies - How our advanced SaaS eWallet Software Solutions have transformed numerous fintech businesses into great success in the financial ecosystem.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const WhitepapersMeta = {
      metaTitle: `Digital Wallet, Prepaid Cards & Payment Platform Whitepapers`,
      metaDescription: "Expand your fintech knowledge on digital wallets, prepaid cards & various other digital payment platforms with our well-researched whitepapers. Download now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const WebinarsMeta = {
      metaTitle: `Cloud Native Fintech Platform | Financial Product Webinars`,
      metaDescription: "We host exclusive financial product webinars with fintech experts to enhance your product knowledge & technical know-how about our cloud-native fintech platform",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const EventsMeta = {
      metaTitle: `Our Participation in Top Global Fintech Exhibitions & Events`,
      metaDescription: "All the top global fintech events we participated in, showcased our fintech solutions & delivered expert insights to leave a mark in the financial ecosystem.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AutomatedFareCollectionMeta = {
      metaTitle: `Automated Fare Collection Software, Ticketing & AFC System`,
      metaDescription: "A reliable automated fare collection solution to streamline your operations, & reduce fare collection costs, with a secure cloud-native ticketing & AFC system.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const CashlessPaymentForEventsMeta = {
      metaTitle: `Cashless Digital Payment Solution for Events & Conferences`,
      metaDescription: "A reliable cashless payment software solution for events, conferences, & concerts powered with NFC & RFID for a seamless payment experience & boosted revenues.",
      ogImage: CashlessPaymentSolutionForEventsAndConferencesOgImage,
      twitterImage: CashlessPaymentSolutionForEventsAndConferencesOgImage
};
export const CashlessPaymentForRestaurantsMeta = {
      metaTitle: `Restaurant & Cafe POS Solution, Best Cafe POS System`,
      metaDescription: "API-driven restaurant & cafe POS solution to delight your customers with easy payments. Win extra edge & boost profits with our cashless payment solution.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ClosedLoopWalletMeta = {
      metaTitle: `Closed-loop eWallet System Solution, Mobile eWallet Software`,
      metaDescription: "A cutting-edge closed loop ewallet system solution designed to deploy a branded closed-loop wallets for your business to boost revenue & customer loyalty.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ContactUsMeta = {
      metaTitle: `Digital Payment Software Solution Provider | DigiPay.Guru`,
      metaDescription: "We are a leading digital payment solution provider focused on offering the best feature-rich fintech solutions. Contact our expert team by filling out this form",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const CryptocurrencyWalletMeta = {
      metaTitle: `Cryptocurreny Digital Wallet Platform, Crypto eWallet :DGpay`,
      metaDescription: "Cryptocurrency Digital Wallet Platform for cloud-native crypto eWallet services with a one-click QR code scan in a quick, secure, seamless, and efficient way.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const DigitalFintechSoftwareSolutionsMeta = {
      metaTitle: `Digital Fintech Solutions, SaaS eWallet Software Solution`,
      metaDescription: "SaaS-based white-label digital fintech software solutions, empowering businesses with seamless, secure, and smart fintech products and financial services.",
      ogImage: DigitalFintechSoftwareSolutionOgImage,
      twitterImage: DigitalFintechSoftwareSolutionOgImage
};
export const EwalletForEticketMeta = {
      metaTitle: `eWallet for ticket booking, e-ticket booking payment solution`,
      metaDescription: "We are the best SaaS eWallet software provider for ticket booking. Advanced e-ticket booking platform for real-time booking and simple, quick & secure payments.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const EwalletForParkingMeta = {
      metaTitle: `eWallet for Parking Payment Solution, Digital Parking Payment`,
      metaDescription: "DigiPay.Guru’s eWallet smart parking payment platform comes with advanced digital payment features. Find, park, and pay for parking directly from the ewallet.",
      ogImage: EwalletForParkingPaymentSolutionsOgImage,
      twitterImage: EwalletForParkingPaymentSolutionsOgImage
};
export const EwalletForTollRoadMeta = {
      metaTitle: `NFC & RFID Enabled Mobile Wallet Toll Payment Solution`,
      metaDescription: "Next-gen toll payment solution to simplify toll payments for users & toll officials making them simple, quick, and convenient with contactless tech- NFC & RFID.",
      ogImage: EwalletForTollRoadPaymentSolutionsOgImage,
      twitterImage: EwalletForTollRoadPaymentSolutionsOgImage
};
export const EwalletFuelSolutionsMeta = {
      metaTitle: `eWallet Fuel Solutions, Mobile Wallet for Fuel Retail`,
      metaDescription: "eWallet fuel payment solution to automate, and make the fueling & payment process quick and easy. Cashless fuel retail solution with API-driven mobile wallets.",
      ogImage: EwalletFuelSolutionsOgImage,
      twitterImage: EwalletFuelSolutionsOgImage
};
export const EwalletResortAndHotelMeta = {
      metaTitle: `Cashless eWallet resort & hotel management software solution`,
      metaDescription: "eWallet resort and hotel management software solution for making hotel stays convenient with a full cashless payment experience for all products and services.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const EwalletForEntertainmentMeta = {
      metaTitle: `Ewallet Theme Park Solution, Amusement Park Solution`,
      metaDescription: "eWallet theme park solutions to boost guest satisfaction & spending in the amusement park. A mobile wallet with a POS system for secure & cashless payments.",
      ogImage: EwalletSolutionForEntertainmentAndAmusementParkOgImage,
      twitterImage: EwalletSolutionForEntertainmentAndAmusementParkOgImage
};
export const LoyaltyAndRewardsSolutionsMeta = {
      metaTitle: `Mobile Wallet Loyalty & Rewards Program Solutions: DGpay`,
      metaDescription: "Smart loyalty and rewards programs to enhance your eWallet platform. Boost revenue, customer engagement & retention, customer loyalty, and profits. DigiPay.Guru",
      ogImage: loyaltyAndRewardsSolutionsOgImage,
      twitterImage: loyaltyAndRewardsSolutionsOgImage
};
export const MicroFinanceSolutionsMeta = {
      metaTitle: `Microfinance Solution & Software | Digital Financial Services`,
      metaDescription: "Reliable digital financial services provider for automated microfinance services & software. Provide instant loans, multi-currency support & holistic user management",
      ogImage: MicroFinanceSolutionsOgImage,
      twitterImage: MicroFinanceSolutionsOgImage
};
export const MposMobilePointOfSaleMeta = {
      metaTitle: `Mobile POS, mPOS Payment Solution, Payment Terminal`,
      metaDescription: "White-label mPOS payment solution with NFC and mobile money system. Boost revenue & enhance payment experience with mobile POS for retailers, restaurants & more",
      ogImage: MposMobilePointOfSaleSolutionsOgImage,
      twitterImage: MposMobilePointOfSaleSolutionsOgImage
};
export const PocketMoneyMeta = {
      metaTitle: `Digital Pocket Money, Sub-wallet Solution for Children`,
      metaDescription: "Our digital pocket money solution is a children’s sub-wallet solution with smart features for parents to manage their finances in a smart, efficient & fun way.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ScheduleMeetingMeta = {
      metaTitle: `DigiPay.Guru is attending WFIS 2023 in Nairobi, Kenya`,
      metaDescription: "DigiPay.Guru will be at the World Financial Innovation Series, Kenya 9th Edition. Network & leverage the knowledge our experts carry and schedule a meeting with us.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ThankYouMeta = {
      metaTitle: `API-Driven Digital Wallet Financial Product | DigiPay.Guru`,
      metaDescription: "You’re one step closer to a reliable API-driven digital wallet financial product for your business. We are a seamless, convenient & customized fintech solution.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const TopupAndBillPaymentMeta = {
      metaTitle: `Mobile Utility Top Up & Bill Payment App Solution Software  `,
      metaDescription: "An integrated top-up, recharge & bill payment Services & solution for your business. We provide PINless top-ups and seamless bill payments through mobile payment apps.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const EvolutionOfDigitalWalletMeta = {
      metaTitle: `An Ultimate guide to digital wallets | eWallet platforms`,
      metaDescription: "A whitepaper curated specially for a detailed insight on all about digital wallet solutions from evolution, models, features, and benefits, to ewallet features.",
      ogImage: EvolutionOfDigitalWalletAndMobilePaymentOgImage,
      twitterImage: EvolutionOfDigitalWalletAndMobilePaymentOgImage
};
export const DownloadCompanyProfileMeta = {
      metaTitle: `Fintech Software Solution Provider Company | DigiPay.Guru`,
      metaDescription: "Our impressive company profile with pioneering digital fintech solutions & financial services catering to NBFIs, Fintech businesses, Banks, MNOs, and Telcos.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ThankYouSchedulingMeetingMeta = {
      metaTitle: `Fintech Partner, Cloud Native eWallet Platform Provider`,
      metaDescription: "We are the ideal fintech partner for your business. Talk to our expert in your scheduled meeting to learn more about our cloud-native eWallet platform.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const PrivacypolicyMeta = {
      metaTitle: `Cloud-native Financial Digital Wallet Software Privacy Policy`,
      metaDescription: "Privacy Policy for our cloud-native financial digital wallet software solutions. Your trust & security matters. We provide complete transparency in our policy.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const EkycSolutionMeta = {
      metaTitle: `eKYC Solution Provider for Banks & Fintechs, Digital KYC App: DGpay`,
      metaDescription: "DigipayGuru is trusted API-driven eKYC solution, empowering banks & financial institutions with seamless, secure & compliant customer onboarding & verification",
      ogImage: EkycSolutionOgImage,
      twitterImage: EkycSolutionOgImage
};

export const MposSolutionMeta = {
      metaTitle: `mPOS Solution, mobile point of sale solutions for Fintechs`,
      metaDescription: "We are a top-notch mPOS solution provider. We offer white-label mPOS solution for payment acceptance through smartphones, wearable devices, and cards.",
      ogImage: MposSolutionOgImage,
      twitterImage: MposSolutionOgImage
};

export const WalletAsServicesMeta = {
      metaTitle: `Wallet-as-a-service, Digital Wallet as a Service | DigiPay.Guru`,
      metaDescription: "We are a reliable and cost-effective wallet-as-a-service specifically designed to simplify your mobile money and digital payment solutions",
      ogImage: WalletAsServicesOgImage,
      twitterImage: WalletAsServicesOgImage
};

export const CardAsServicesMeta = {
      metaTitle: `Card Issuing as a Service & Software | Card Issuance Platform`,
      metaDescription: "Digipay Guru offers a reliable, secure and cost-effective card payment & issuing as a service for managing & issuing credit, debit & prepaid card solutions.",
      ogImage: CardAsServicesOgImage,
      twitterImage: CardAsServicesOgImage
};

export const EKycAsServicesMeta = {
      metaTitle: `Digital Onboarding as a Service, eKYC as a Service`,
      metaDescription: "We offer a robust and efficient eKYC-as-a-service solution to banks and fintechs for delivery a fast, seamless, & secure onboarding and verification experience",
      ogImage: EKycAsServicesOgImage,
      twitterImage: EKycAsServicesOgImage
};

export const TransformingKycExperienceForBanksMeta = {
      metaTitle: `Transforming KYC experience for banks with KYC automation`,
      metaDescription: "With this insightful whitepaper, explore the potential challenges banks face with traditional KYC processes and how modern KYC solutions can help overcome them.",
      ogImage: TransformingKycExperienceForBanksOgImage,
      twitterImage: TransformingKycExperienceForBanksOgImage
};

export const PrepaidCardRetailRevolutionMeta = {
      metaTitle: `Transforming the retail landscape with prepaid card solutions`,
      metaDescription: "Prepaid card solution for retailers - whitepaper! Discover the challenges faced by the retailers and how prepaid card solutions can change their business.",
      ogImage: PrepaidCardRetailRevolutionOgImage,
      twitterImage: PrepaidCardRetailRevolutionOgImage
};

export const AgencyBankingInEastAfricaMeta = {
      metaTitle: `Agency Banking in East Africa -Whitepaper | DigiPay.Guru`,
      metaDescription: "Explore the Agency Banking market in the top 10 countries of East Africa. Learn the challenges, opportunities, technology & regulatory framework. DigiPay.Guru",
      ogImage: AgencyBankingInEastAfricaOgImage,
      twitterImage: AgencyBankingInEastAfricaOgImage
};

// export const ProductUpdateMeta = {
//       metaTitle: `Transforming KYC experience for banks with KYC automation`,
//       metaDescription: "With this insightful whitepaper, explore the potential challenges banks face with traditional KYC processes and how modern KYC solutions can help overcome them.",
//       ogImage: SocialDefaultImage,
//       twitterImage: SocialDefaultImage
// };

export const EkycPricingMeta = {
      metaTitle: `Digital Onboarding as a Service, eKYC as a Service`,
      metaDescription: "We offer a robust and efficient eKYC-as-a-service solution to banks and fintechs for delivery a fast, seamless, & secure onboarding and verification experience",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const MobileMoneyPricingMeta = {
      metaTitle: `Affordable Mobile Money Pricing Plans | Flexible & Transparent | Digipay.guru`,
      metaDescription: "Explore our transparent and cost-effective mobile money pricing plans tailored to meet your needs. Enjoy secure transactions, flexible options, and no hidden charges. Visit now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const FaceVerificationMeta = {
      metaTitle: `DGpay Face Recognition & Identity Verification | eKYC Feature`,
      metaDescription: "Eliminate spoof attacks and face fraudulent activities with instant yet accurate face Recognition & Identity verification results to ensure high security & KYC compliance",
      ogImage: FaceVerificationOgImage,
      twitterImage: FaceVerificationOgImage
};
export const DocumentVerificationMeta = {
      metaTitle: `Document verification for advanced security in eKYC solution`,
      metaDescription: "Verify customers and prevent fraud with real-time document verification. DigiPay.Guru’s AI-powered document checks identify document fraud in less than a second",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const AmlscreeningMeta = {
      metaTitle: `DigiPay.Guru’s eKYC solution for robust AML screening`,
      metaDescription: "Prevent your business from money laundering, fraud, or other financial crimes with DigiPay.Guru’s AML screening, and always stay super secure and compliant.",
      ogImage: AmlScreeningOgImage,
      twitterImage: AmlScreeningOgImage
};
export const AddressVerificationMeta = {
      metaTitle: `DGPay Address verification | Verify users with complete accuracy`,
      metaDescription: "Verify document address effectively to prevent identity fraud with DigiPay.Guru’s advanced address verification service | digipay.guru eKYC solution",
      ogImage: AddressVerificationOgImage,
      twitterImage: AddressVerificationOgImage
};

export const MerchantacquiringPageMeta = {
      metaTitle: `Merchant Acquiring Solution & Services | Payment Acquirer`,
      metaDescription: "Robust merchant acquiring solutions for banks and fintech to offer seamless payment acceptance to merchants. Merchant acquiring payment solutions - DigiPay.Guru",
      ogImage: MerchantAcquiringSolutionOgImage,
      twitterImage: MerchantAcquiringSolutionOgImage
};

export const InvoicepaymentsMeta = {
      metaTitle: `Invoice payment | Merchant acquiring solution | DigiPay.Guru`,
      metaDescription: "Offer seamless & configurable invoice payments to merchants via payment links. Simplify payment acceptance with DigiPay.Guru’s merchant acquiring solution.",
      ogImage: InvoicePaymentsMerchantAcquiringSolutionOgImage,
      twitterImage: InvoicePaymentsMerchantAcquiringSolutionOgImage
};

export const QrPaymentsMeta = {
      metaTitle: `QR payments | Merchant acquiring solution | DigiPay.Guru`,
      metaDescription: "QR payments feature - merchant acquiring solution. Offer merchants an effective way to accept payment with an easy-to-use, cost-effective & secure payment mode.",
      ogImage: QrPaymentsMerchantAcquiringSolutionOgImage,
      twitterImage: QrPaymentsMerchantAcquiringSolutionOgImage
};

export const TapToPhoneMerchantAcquiringSolutionMeta = {
      metaTitle: `Tap on Phone Payment, Contactless Payment, Mobile Tap to Pay`,
      metaDescription: "Make receiving payments fast, easy, convenient, and secure for your merchants with DigiPay.Guru’s tap to phone feature of merchant acquiring solution",
      ogImage: TapToPhoneMerchantAcquiringSolutionOgImage,
      twitterImage: TapToPhoneMerchantAcquiringSolutionOgImage
};

export const PriceBasedSmartRoutingMeta = {
      metaTitle: `Priced-based smart routing - DigiPay.Guru`,
      metaDescription: "Discover how price-based smart routing enhances efficiency, reduces costs, and improves customer satisfaction for your international remittance business.",
      ogImage: TapToPhoneMerchantAcquiringSolutionOgImage,
      twitterImage: TapToPhoneMerchantAcquiringSolutionOgImage
};

export const HostCardEmulationForEwalletMeta = {
      metaTitle: `Host Card Emulation | HCE Payment & Wallet | DigiPay.Guru`,
      metaDescription: "Transform your eWallet experience with Host Card Emulation. Ensure secure, efficient, and contactless payments tailored for banks and fintech. DigiPay.Guru.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const DigitalPaymentSolutionsForFintechsMeta = {
      metaTitle: `Fintech Solutions & Financial Management Software | Digipay.Guru`,
      metaDescription: "Discover how DigiPay.Guru's Financial payment solutions can address your fintech challenges, enhance customer experiences, and drive business growth effectively.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const DigitalFintechSolutionsForTelcosMeta = {
      metaTitle: `Digital Payment Solutions for Telcos By DigiPay.Guru`,
      metaDescription: "Empower your telco with secure & scalable financial services. Enhance customer experience, reduce costs, and drive growth with DigiPay.Guru’s expert solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AgentcashinoutbankMeta = {
      metaTitle: `Agent Cash-in Cash-out for Agency Banking Solution `,
      metaDescription: "Explore the key features of DigiPay.Guru’s advanced agency banking solution: Agent cash-in cash-out. Agent cash in cash out solutions for agency banking",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const CrossborderbillpaymentirMeta = {
      metaTitle: `Cross Border Bill Payments | Cross Border Fee, Financing, Banking`,
      metaDescription: "Get a reliable and fast cross border bill payments feature for your international remittance platform with DigiPay.Guru’s cross border remittance solution.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const MobileMoneyFeaturesMeta = {
      metaTitle: `Mobile money/eWallet solution features | DigiPay.Guru`,
      metaDescription: "Mobile money solution and eWallet software features include wallet models, onboarding, flexible payment channels, agent networks, bulk payments, & more. DigiPay.Guru",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const InternationalRemittanceFeaturesMeta = {
      metaTitle: `International Remittance Solution Features | DigiPay.Guru`,
      metaDescription: "Cross border remittance platform features include currency corridors, rate management, agent network modules, smart routing, bill payments & more. DigiPay.Guru",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AgentcommissionmanagementPageMeta = {
      metaTitle: `Agent Commission Management | Agency Banking Solution | DigiPay.Guru`,
      metaDescription: "Explore DigiPay.Guru’s customizable agent commission model for banking agents in our agency banking solution to keep your agents happy and coming back.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const MerchantAcquiringFeaturesMeta = {
      metaTitle: `Merchant Acquiring Solution Features | DigiPay.Guru`,
      metaDescription: "Merchant acquiring solution features include merchant onboarding & management, payment acceptance, transaction & risk management, merchant dashboard, and more",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const FintechDigitalPaymentsInNigeriaMeta = {
      metaTitle: `Fintech Digital Payment Solution Platform in Nigeria by DigiPay.Guru`,
      metaDescription: "Fast, secure, and scalable digital payment solutions Platform in Nigeria to empower your business. Solutions ranging from eWallet, cross-border remittance, and more.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const UgandafintechbankingdigitalpaymentsolutionsMeta = {
      metaTitle: `Digital Payment Solutions in Uganda | DigiPay.Guru`,
      metaDescription: "Launch secure digital payment solutions in Uganda including mobile money, agency banking, global remittance, and more, with a scalable fintech platform.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const OnlinefintechdigitalpaymentsinsouthafricaMeta = {
      metaTitle: `Fintech Digital Payment Solutions in South Africa by DigiPay.Guru`,
      metaDescription: "Explore DigiPay.Guru’s secure, scalable digital payment solutions in South Africa. Serve customers better with eWallets, global remittance, prepaid cards, & more.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const EvolutionofcrossborderremittanceswhitepaperMeta = {
      metaTitle: `Evolution of Cross-Border Remittances - Whitepaper | DigiPay.Guru`,
      metaDescription: "Explore cross-border remittances' evolution from cash to digital and how it affected the remittance industry. The regulatory frameworks. The future. And more.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
// export const ComparePageMeta = {
//       metaTitle: `Compare Digital Payment Solutions | Digipay Guru vs Competitors`,
//       metaDescription: "See how Digipay Guru stacks up against top payment platforms. Compare features, pricing, security, and scalability to find the best digital payment solution for your business.",
//       ogImage: SocialDefaultImage,
//       twitterImage: SocialDefaultImage
// };
export const EthiopiafintechmeetMeta = {
      metaTitle: `Meet DigiPay Guru in Ethiopia – June 2025 Fintech Tour`,
      metaDescription: "Join DigiPay Guru in Addis Ababa, 16–23 June 2025. Let’s connect to explore fintech innovations like mobile money, cross-border remittance, agency banking, & more",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

// export const GettingStartedMeta = {
//       metaTitle: `Getting started | DigiPay.Guru`,
//       metaDescription: "Getting started | DigiPay.Guru",
//       ogImage: SocialDefaultImage,
//       twitterImage: SocialDefaultImage
// };
